import { StyleSheet, View } from "react-native";
import { ThemedText } from "@/components/ThemedText";
import { Link, Stack } from "expo-router";
import { useTheme } from "@/hooks/useTheme";

export default function NotFoundScreen() {
  const { colors } = useTheme();
  return (
    <>
      <Stack.Screen options={{ title: "Oops! Not Found" }} />
      <View style={[styles.container, { backgroundColor: colors.background }]}>
        <Link href="/" style={styles.button}>
          <ThemedText>404 Go back to Home screen!</ThemedText>
        </Link>
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },

  button: {
    fontSize: 20,
    textDecorationLine: "underline",
  },
});
